import TertiaryButton from "../buttons/TertiaryButton";
import InputLabel from "./InputLabel";
import { getMaxLength } from "../commonfunctions/getMaxLength";
import ErrorMessage from "../ErrorMessages/ErrorMessage";
import { validateInput } from "../commonfunctions/validateInput";
import { useEffect, useState } from "react";
import OTPVerification from "../Verifications/OTPVerification";
import Image from "../images/Image";
import InputFramer from "../framerMotion/InputFramer";
import InputShimmer from "./InputShimmer";
import useTranslation from "../CustomHooks/useTranslation";
import { inputFieldContent } from "./InputFieldContent";
interface InputItem {
  labelName: string;
  id: string;
}

interface InputFieldProps {
  inputItem: InputItem;
  errorMessage?: string;
  required?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  fieldError?: string;
  tabIndex: number; // Total number of input fields to determine navigation
  maxLength?: number;
  testId?: string;
  disabled?: boolean;
  value?: string;
  handleVerify: (id: string, resend: boolean) => void;
  handleSubmitOTP: () => void;
  isVerified: string;
  ButtonLoading?: boolean;
  editLoading?: boolean;
  isOpenOtpModel?: boolean;
  setIsOpenOtpModel?: React.Dispatch<React.SetStateAction<boolean>>;
  validation?: boolean;
  mapping?:boolean;
}

export default function InputfieldWithVerification({
  inputItem,
  errorMessage,
  onChange,
  required,
  tabIndex,
  fieldError,
  maxLength,
  testId,
  disabled,
  handleVerify,
  handleSubmitOTP,
  isOpenOtpModel,
  setIsOpenOtpModel,
  isVerified,
  value,
  ButtonLoading,
  editLoading,
  validation = true,
  mapping
}: InputFieldProps) {
  const { labelName, id } = inputItem;
  const [isError, setIsError] = useState("");
  const [inputValue, setInputValue] = useState<string>("");
  const [isModelOpen, setIsModelOpen] = useState(false);
  const { translate, replace, notEnglish } = useTranslation(inputFieldContent);
  const handleClickVerify = () => {
    setIsModelOpen(true);
    if (id === "email_address" || id === "official_email_address") {
      let inputValidationErrors: Record<string, string> = {};
      if (validation) {
        inputValidationErrors = validateInput({
          [id]: inputValue ?? "",
        });
        if (Object.keys(inputValidationErrors).length > 0) {
          setIsError(inputValidationErrors[id] || "");
          return;
        }
      } else {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (inputValue !== '' && !regex.test(inputValue)) {
          setIsError("Please enter a valid email address");
          return;
        }
      }
      handleVerify(id, false);
    }
  };
  // Handle change event with max length restriction
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const maxLength = getMaxLength(id);
    let { value } = event.target;
    setIsError("");

    if (id === "email_address" || id === "official_email_address") {
      // Remove any spaces from the email address
      value = value.replace(/\s/g, ""); // This removes all spaces
    }

    // Restrict the input value to the max length
    if (maxLength !== undefined && value.length > maxLength) {
      value = value.slice(0, maxLength);
    }

    // Update the value of the input field
    event.target.value = value;
    setInputValue(value);
    if (onChange) {
      onChange(event); // Trigger the parent onChange handler
    }
  };
  // Handle keydown event for arrow navigation
  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    // Arrow Down or Right
    // if (event.key === "ArrowDown" || event.key === "ArrowRight") {
    //   const nextInput = document.querySelectorAll("input")[
    //     tabIndex + 1
    //   ] as HTMLInputElement;
    //   if (nextInput) {
    //     nextInput.focus();
    //   }
    // }
    // // Arrow Up or Left
    // else if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
    //   const previousInput = document.querySelectorAll("input")[
    //     tabIndex - 1
    //   ] as HTMLInputElement;
    //   if (previousInput) {
    //     previousInput.focus();
    //   }
    // }
  };
  useEffect(() => {
    if (!isOpenOtpModel) {
      setIsModelOpen(false);
    }
  }, [isOpenOtpModel]);
  return (
    <InputFramer>
      <InputLabel labelName={labelName} id={id} required={required} />
      {/* if error occers change it to border color border-negative */}

      {editLoading ? (
        <InputShimmer />
      ) : (
        <div className={`${mapping ? 'w-full' : 'w-80'}  relative `}>
          <input
            id={id}
            data-testid={testId || id}
            className={`w-full h-14 py-5 ${isVerified
              ? "pr-[45px]"
              : ButtonLoading
                ? "pr-[53px]"
                : !notEnglish ? 'pr-[68px]' : (notEnglish && value !== '') ? "pr-[120px]" : 'pr-[20px]'
              }  disabled:cursor-not-allowed pl-2.5 focus:pl-[9px] disabled:bg-disable_fill disabled:border-disable_stroke border rounded-lg text-subTitle outline-none focus:border-2 ${errorMessage || fieldError || isError
                ? "border-negative"
                : "border-P_light_active"
              }`}
            placeholder={translate(`Enter ${labelName.toLocaleLowerCase()}`)}
            onChange={handleChange} // Use the updated onChange handler
            onKeyDown={handleKeyDown} // Handle arrow key navigation
            tabIndex={tabIndex + 1} // Ensure correct tab order for navigation
            autoComplete="off"
            maxLength={maxLength}
            disabled={disabled}
            value={value}
          />
          <span
            className={`absolute ${isVerified
              ? " top-[19px] right-[20px]"
              : ButtonLoading
                ? "top-[15px] right-[20px]"
                : !notEnglish ? "top-2 right-[10px]" : "w-[7rem] top-2 right-[20px]"
              }`}
          >
            {isVerified === 'true' ? (
              <Image src="success-tick" className="h-5 w-5" />
            ) : disabled && !ButtonLoading ? (
              ""
            ) : (
              inputValue?.length !== 0 && (
                <TertiaryButton
                  testId={`${id}_verify`}
                  buttonName={translate("Verify")}
                  id="Verify"
                  handleClick={handleClickVerify}
                  loading={ButtonLoading}
                  className={'w-full '}
                />
              )
            )}
          </span>
        </div>
      )}
      {/* if error comes please change show the error message  */}
      {(errorMessage || isError) && !disabled && (
        <ErrorMessage errorMessage={errorMessage || isError} />
      )}
      {isOpenOtpModel && isModelOpen && (
        <OTPVerification
          handleSubmitOTP={handleSubmitOTP}
          handleClickResendOTP={handleVerify}
          instructionText={replace(`We have sent a code to {{email_or_phone}}`, {
            email_or_phone: `${value}`,
          })}
          otp_id={id}
          handleClose={() => {
            setIsOpenOtpModel && setIsOpenOtpModel(false);
            setIsModelOpen(false);
          }}
        />
      )}
    </InputFramer>
  );
}
